module.exports = __webpack_public_path__ + "static/noticias-10-21d365b463099f891bb567488fb0f3e3.jpg";